var $ = jQuery;

$(document).ready(function(){

    $('.hero_button__replaced--trigger, .landing_dec_product_tile').on( "click", function(){
        $('.pop_up_form__landing').addClass('active');
        $('.header_overlay').addClass('active--3');
        $('body').css('overflow', 'hidden');
    });

    function closeLanding2024PopUpForm(){
        console.log("remove");
        $('.pop_up_form__landing').removeClass('active');
        $('.header_overlay').removeClass('active--3');
        $('body').css('overflow', 'unset');
    }

    $('.pop_up_form__landing .button_functionality').on( "click", function(){
        closeLanding2024PopUpForm();
    });

    $('.pop_up_form__landing').on( "click", function(e){
        if(e.target === this) {
            closeLanding2024PopUpForm();
        }
    });
});